export default __webpack_public_path__ + "static/media/ArrowNoCircleDark.eec47c76.svg";